<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <!-- page Title -->
      <i-card-vertical headerTitle="작업공정 안전보건정보 작성" device="web">
        <template v-slot:body>
          <v-sheet class="tab-layout">
            <!-- 좌측 tab -->
            <v-sheet class="tab-left">
              <v-select
                :value="searchRiskAssessment"
                :menu-props="{ offsetY: true }"
                :items="riskAssessmentList"
                item-text="riskAssessmentNm"
                item-value="assessmentKey"
                class="search-select editor_bg"
                placeholder="위험성평가명"
                solo
                @change="changeRiskAssessment"
              ></v-select>
              <v-card color="inner_card_bg" class="overflow-y-auto">
                <v-list class="pa-0 contents-menu">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, index) in tabList"
                      :key="item.index"
                      @click="handleTabClick(index)"
                      :class="{ active: selectedKey === index }"
                    >
                      <v-list-item-content>{{ item.name }}</v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-sheet>
            <!-- 우측 테이블 영역 -->
            <!-- table -->
            <v-card :class="breakpoint === 'md' || breakpoint === 'sm' || breakpoint === 'xs' ? 'mt-5' : ''">
              <div v-show="selectedKey === 0">
                <div class="editor-title d-flex align-center">
                  <span>적용된 공정 수: {{ applyProcessCnt }}</span>
                  <span class="mx-2 editor-subTitle btn_outline--text">|</span>
                  <span v-if="!fileMode">적용된 작업 수: {{ applyWorkCnt }}</span>

                  <v-tooltip right>
                    <template v-slot:activator="{ on }">
                      <v-icon small color="primary" v-on="on">mdi-information-outline</v-icon>
                    </template>
                    <div>{{ '적용된 항목 수는 저장 후 갱신됩니다.' }}</div>
                  </v-tooltip>
                </div>
                <process-panel-tree
                  ref="processPanelTree"
                  class="mt-5 custom-panel"
                  :fileMode="fileMode"
                  :assessmentKey="searchRiskAssessment"
                  :datasource="datasource"
                  :searchProcess="searchProcess"
                  :changedFlag="changedFlag"
                  :readonly="readOnlyFlag"
                  @titleClick="titleClick"
                  @apply="apply"
                />
              </div>

              <div v-show="selectedKey === 1">
                <v-row no-gutters align="center" class="icardTop">
                  <v-col cols="5" class="d-flex">
                    <v-select
                      :value="searchProcess"
                      :menu-props="{ offsetY: true }"
                      :items="detailProcessList"
                      item-text="processNm"
                      item-value="processId"
                      class="search-select editor_bg"
                      placeholder="공정명"
                      solo
                      @change="changeProcess"
                    />
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon small color="primary" v-on="on">mdi-information-outline</v-icon>
                      </template>
                      <div>{{ '적용중인 공정만 조회 가능합니다.' }}</div>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="7" class="d-flex justify-end">
                    <v-btn color="primary" large @click="btnSample">예시 불러오기</v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <process-information
                    v-if="processShInfoReady"
                    ref="processInformation"
                    :key="`${searchRiskAssessment}_${searchConstructId}_${searchProcess}`"
                    :propsData="processShInfo"
                    :pk="`${searchRiskAssessment}_${searchConstructId}_${searchProcess}`"
                  />
                </v-row>
              </div>
            </v-card>
          </v-sheet>
        </template>
        <template v-slot:drawer>
          <v-navigation-drawer v-model="procedureShow" width="75%" absolute right temporary class="feedback-area">
            <ProcedureComponent :type="'00002'" />
          </v-navigation-drawer>
        </template>
      </i-card-vertical>
      <v-sheet class="iCardRightWrap">
        <i-card-right
          class="d-md-flex"
          :useBtnList="buttonUseList"
          @btnSearch="btnSearch(true)"
          @btnSave="btnSave"
          @btnPrint="btnPrint"
        ></i-card-right>
        <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button color="btn_text" :text="'개설 이동'" :icon="'back'" @click="btnOpen" :appendDivider="false"></i-icon-button>
            <!-- <i-icon-button color="btn_text" :text="'작성 이동'" :icon="'forward'" @click="btnWrite"></i-icon-button> -->
          </template>
        </i-card-right>
        <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button color="btn_text" :text="'절차서'" :icon="'file'" @click="procedureShow = !procedureShow"></i-icon-button>
          </template>
        </i-card-right>
      </v-sheet>
    </v-sheet>
  </v-container>
</template>
<script>
import notify from 'devextreme/ui/notify'
import { AesDecrypt } from '@/utils/aes256'

import baseview from '@/views/base/baseview.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import ProcessPanelTree from './components/ProcessPanelTree.vue'
import ProcessInformation from './components/ProcessInformation.vue'
import ProcedureComponent from '@/views/procedure/components/ProcedureComponent.vue'

import {
  getRiskAssessments,
  getWorkDetails,
  getProcessShInfo,
  getProcessShInfoSample,
  getRiskAssessmentProcesses,
  saveRiskAssessments,
  saveRiskAssessmentShInfo,
  // saveRiskAssessmentWorks,
  getRiskAssessmentProcessReport,
} from '@/api/riskAssessment/riskAssessmentProcess.js'

export default {
  mixins: [baseview, BaseDataGrid],
  components: {
    'process-panel-tree': ProcessPanelTree,
    'process-information': ProcessInformation,
    // 절차서 컴포넌트
    ProcedureComponent,
  },

  data() {
    return {
      initCompId: '',
      buttonUseList: [
        'btnSearch', //조회
        'btnSave',
        'btnPrint',
      ],
      selectedKey: 0,
      tabList: [
        {
          name: '공정 적용',
        },
        {
          name: '안전보건정보',
        },
      ],
      riskAssessmentList: [],
      workList: [],
      searchRiskAssessment: '',
      searchProcess: '',
      searchConstructId: '',
      processCnt: 0,
      workCnt: 0,
      processArray: [],
      expandedPanel: [],
      datasource: [],
      detailProcessList: [],
      processShInfo: {
        workerList: [],
        regulationList: [],
        itemList: [],
        msdsList: [],
        damageList: [],
        workerMinCnt: 0,
        checklist: {},
      },
      processShInfoReady: false,
      selectedProcess: {},
      changedFlag: false,
      applyProcessCnt: 0,
      applyWorkCnt: 0,
      // 절차서 컴포넌트
      procedureContent: '',
      procedureShow: false, // 절차서 보이기
      readOnlyFlag: false,
      fileMode: false,
    }
  },
  created() {
    // 초기 페이지 진입 시 compId 세팅
    this.initCompId = this.getCompId()
    this.setComboBox()
  },
  activated() {
    if (this.$route.params.data) {
      let data = this.$route.params.data
      console.log(data)
      this.searchRiskAssessment = data.clntId + '_' + data.compId + '_' + data.writeDt + '_' + data.docNo
      this.searchProcess = ''
      this.selectedKey = 0
      this.setComboBox()
      this.btnSearch(true)
    }
    if (this.changedCompFlag(this.initCompId)) {
      this.changedFlag = true
      this.selectedKey = 0
      // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
      // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
      this.searchRiskAssessment = ''
      this.initCompId = this.getCompId()
      this.setComboBox()
      this.btnSearch(true)
    }
  },
  async beforeMount() {},
  mounted() {},
  computed: {
    mobileTrigger: function () {
      return this.width < 800
    },
    breakpoint() {
      return this.$vuetify.breakpoint.name
    },
  },
  methods: {
    async btnSample() {
      this.vToastifyPrompt(this.$t('작성중인 내용이 덮어집니다. 예시를 불러오시겠습니까?'), 'info', async (current) => {
        this.openLoading()
        const param = {
          constructId: this.searchConstructId,
          processId: this.searchProcess,
        }
        getProcessShInfoSample(param, true)
          .then((res) => {
            console.log(res)
            this.processShInfo = res
            if (res.checklist) {
              this.processShInfo.checklist = JSON.parse(res.checklist)
            }
          })
          .catch(() => {
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
          })
      })
    },
    async btnSearch(isNotify) {
      const [clntId, compId, writeDt, docNo] = this.searchRiskAssessment.split('_')
      // this.datasource = []
      this.applyProcessCnt = 0
      this.applyWorkCnt = 0
      let params = {
        clntId: clntId,
        compId: compId,
        writeDt: writeDt,
        docNo: docNo,
      }
      // 안전보건정보 탭: 공정 목록 조회 후 getProcessShInfo까지 끝난 뒤 props 전달·렌더
      if (this.selectedKey == 1) {
        if (!this.searchRiskAssessment) {
          this.vSnackbar(this.$t('위험성평가를 선택해주세요.'), 'warning')
          this.selectedKey = 0
          return
        }
        this.processShInfoReady = false
        this.openLoading('searching')
        // getRiskAssessmentProcesses(params, isNotify)
        //   .then((response) => {
        // this.datasource = response.list
        // this.searchConstructId = this.datasource[0]?.constructId
        this.detailProcessList = this.datasource.filter((element) => !element.__created__ && element.useYn == 'Y')
        if (this.detailProcessList.length === 0) {
          this.processShInfoReady = false
        }

        if (this.detailProcessList.filter((element) => element.processId == this.searchProcess).length == 0) {
          this.searchProcess = this.detailProcessList[0]?.processId
          this.searchConstructId = this.detailProcessList[0]?.constructId
          console.log('### this.searchProcess', this.searchProcess, this.searchConstructId)
        }

        params.constructId = this.searchConstructId
        params.processId = this.searchProcess
        return (
          getProcessShInfo(params, isNotify)
            // })
            .then((shResponse) => {
              if (!shResponse || shResponse.success === false) {
                this.processShInfoReady = false
                return
              }
              this.processShInfo =
                shResponse != null
                  ? shResponse
                  : {
                      workerList: [],
                      regulationList: [],
                      itemList: [],
                      msdsList: [],
                      damageList: [],
                      workerMinCnt: 0,
                      checklist: {},
                    }
              if (shResponse?.checklist) {
                this.processShInfo.checklist = JSON.parse(shResponse.checklist)
              }
              this.processShInfoReady = true
            })
            .catch(() => {
              this.processShInfoReady = false
            })
            .finally(() => {
              this.endLoading()
            })
        )
      }
      // 공정 적용 탭
      this.openLoading('searching')
      getRiskAssessmentProcesses(params, isNotify)
        .then((response) => {
          if (response.success && response.list.length > 0) {
            this.datasource = response.list
            this.searchConstructId = this.datasource[0].constructId
            if (this.readOnlyFlag) {
              this.datasource
                .filter((el) => el.useYn === 'Y')
                .forEach((el) => {
                  el.works = el.works.filter((work) => work.useYn === 'Y')
                })
              this.datasource = this.datasource.filter((element) => element.useYn === 'Y')
            }
            this.detailProcessList = response.list.filter((element) => !element.__created__ && element.useYn == 'Y')

            this.applyProcessCnt = this.getProcessCnt()
            this.applyWorkCnt = this.getWorkCnt()
            const findData = this.riskAssessmentList.find((el) => el.assessmentKey === this.searchRiskAssessment)
            if (findData) {
              findData.riskEstimationVal1 == '' || findData.riskEstimationVal1 == null ? (this.fileMode = true) : (this.fileMode = false)
            }
            if (this.fileMode) {
              this.tabList = [
                {
                  name: '공정 적용',
                },
              ]
            } else {
              this.tabList = [
                {
                  name: '공정 적용',
                },
                {
                  name: '안전보건정보',
                },
              ]
            }
            setTimeout(() => {
              this.$refs.processPanelTree.collapseAllPanel()
            }, 200)
          }
        })
        .finally(() => {
          this.endLoading()
        })
    },
    async btnSave() {
      //공정 적용 탭
      let data = this.datasource.filter((element) => !element.__created__ || (element.__created__ && element.processNm))
      data.forEach((element) => {
        element.works = element.works.filter((work) => !work.__created__ || (work.__created__ && work.workNm))
      })
      if (this.selectedKey == 0) {
        if (!this.searchRiskAssessment) {
          this.vSnackbar(this.$t('위험성평가를 선택해주세요.'), 'warning')
          return
        }
        this.vToastifyPrompt(
          this.$t('doSaveData'),
          'info',
          async (current) => {
            //생성 후 미입력 데이터 필터링
            let data = this.datasource.filter((element) => !element.__created__ || (element.__created__ && element.processNm))
            data.forEach((element) => {
              element.works = element.works.filter((work) => !work.__created__ || (work.__created__ && work.workNm))
              const useYnFilter = element.works.filter((work) => work.useYn == 'Y')
              if (element.works.length > 0 && useYnFilter.length === 0) {
                element.useYn = 'N'
              }
            })
            this.openLoading('saving')
            saveRiskAssessments(data, true)
              .then(async (response) => {
                if (response.success) {
                  //
                  // const fileSaved = await this.$refs.processPanelTree.btnSave()
                  // if (fileSaved) {
                  // this.btnSearch()
                  // }
                }
              })
              .catch((error) => {
                console.error('btnsave error catch >> ', error)
              })
              .finally(() => {
                this.endLoading()
              })
          },
          null,
          true
        )
      }

      //안전보건정보
      if (this.selectedKey == 1) {
        this.vToastifyPrompt(
          this.$t('doSaveData'),
          'info',
          async (current) => {
            const success = await this.saveShInfo()
            if (success) {
              this.btnSearch(true)
            }
          },
          null,
          true
        )
      }
    },
    saveShInfo() {
      this.openLoading()
      const saveData = this.$refs.processInformation.getData()
      return new Promise((resolve, reject) => {
        const [clntId, compId, writeDt, docNo] = this.searchRiskAssessment.split('_')
        saveData.clntId = clntId
        saveData.compId = compId
        saveData.writeDt = writeDt
        saveData.docNo = docNo
        saveData.constructId = this.searchConstructId
        saveData.processId = this.searchProcess
        saveRiskAssessmentShInfo(saveData, true)
          .then(async (response) => {
            const fileSaved = await this.$refs.processInformation.btnFileSave()
            if (fileSaved) {
              resolve(true)
            }
          })
          .catch((error) => {
            resolve(false)
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
          })
      })
    },
    btnPrint(type) {
      if (!this.searchRiskAssessment) {
        this.vSnackbar(this.$t('출력할 문서가 없습니다.'), 'warning')
        return
      }
      const [clntId, compId, writeDt, docNo] = this.searchRiskAssessment.split('_')
      let param = {
        type: type,
      }
      if (this.selectedKey == 0) {
        param.voList = this.datasource.filter((el) => el.useYn === 'Y')
      }
      if (this.selectedKey == 1) {
        let vo = {
          clntId: clntId,
          compId: compId,
          writeDt: writeDt,
          docNo: docNo,
          constructId: this.searchConstructId,
          processId: this.searchProcess,
        }
        param.voList = [vo]
      }
      if (param.voList.length === 0) {
        this.vSnackbar(this.$t('출력할 데이터가 없습니다.'), 'warn')
        return
      }
      this.openLoading()
      getRiskAssessmentProcessReport(param, true)
        .then((response) => {
          this.downloadReport(response)
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },
    async btnOpen() {
      if (!this.searchRiskAssessment) {
        this.vSnackbar(this.$t('위험성평가를 선택해주세요.'), 'warning')
        return
      }
      let saveData = []
      if (this.selectedKey === 0) saveData = this.$refs.processPanelTree.datasource.filter((el) => el.__created__ || el.__updated__)
      if (saveData.length === 0) {
        this.vToastifyPrompt(this.$t(`위험성평가 개설 페이지로 이동하시겠습니까?`), 'info', async (current) => {
          const [clntId, compId, writeDt, docNo] = this.searchRiskAssessment.split('_')
          let data = {
            clntId: clntId,
            compId: compId,
            writeDt: writeDt,
            docNo: docNo,
          }
          const toRouter = {
            name: 'RiskAssessmentManageDetail',
            params: {
              data: data,
            },
          }
          this.$router.push(toRouter)
        })
      } else {
        const [clntId, compId, writeDt, docNo] = this.searchRiskAssessment.split('_')
        let data = {
          clntId: clntId,
          compId: compId,
          writeDt: writeDt,
          docNo: docNo,
        }
        const toRouter = {
          name: 'RiskAssessmentManageDetail',
          params: {
            data: data,
          },
        }
        this.vToastifySavePrompt(
          this.$t(`작성중인 데이터를 저장하고<br/> 위험성평가 개설 페이지로 이동하시겠습니까?`),
          'info',
          async (current) => {
            // 저장 O, 페이지 이동 O
            this.openLoading()
            if (this.selectedKey === 0) {
              saveRiskAssessments(saveData, true)
                .then((response) => {
                  if (response.success) {
                    //
                  }
                })
                .catch((error) => {
                  console.error('btnsave error catch >> ', error)
                })
                .finally(() => {
                  this.endLoading()
                  this.$router.push(toRouter)
                })
            } else {
              const success = await this.saveShInfo()
              if (success) {
                this.$router.push(toRouter)
              }
            }
          },
          async (current) => {
            // 저장 X, 페이지 이동 O
            this.$router.push(toRouter)
          }
        )
      }
    },
    async btnWrite() {
      if (this.selectedProcess.__created__) {
        this.vSnackbar(this.$t('저장되지 않은 공정입니다.'), 'warning')
        return
      }
      console.log('### selectedProcess', this.selectedProcess, this.searchProcess)
      if (!this.selectedProcess.processId && !this.searchProcess) {
        this.vSnackbar(this.$t('선택된 공정이 없습니다.'), 'warning')
        return
      }
      let saveData = []
      if (this.selectedKey === 0) saveData = this.$refs.processPanelTree.datasource.filter((el) => el.__created__ || el.__updated__)
      let data = {
        clntId: this.selectedProcess.clntId,
        compId: this.selectedProcess.compId,
        writeDt: this.selectedProcess.writeDt,
        docNo: this.selectedProcess.docNo,
        constructId: this.selectedProcess.constructId,
        processId: this.selectedProcess.processId,
        __created__: false,
      }
      const toRouter = {
        name: 'RiskAssessmentCreation',
        params: {
          data: data,
        },
      }
      let process = this.detailProcessList.find((el) => el.processId === this.searchProcess)
      if (saveData.length === 0) {
        this.vToastifyPrompt(
          this.$t(`[${process.processNm ? process.processNm : this.selectedProcess.processNm}]<br/>위험성평가 작성 페이지로 이동하시겠습니까?`),
          'info',
          async (current) => {
            this.$router.push(toRouter)
          }
        )
      } else {
        this.vToastifySavePrompt(
          this.$t(
            `작성중인 데이터를 저장하고<br/>[${
              process.processNm ? process.processNm : this.selectedProcess.processNm
            }]<br/>위험성평가 작성 페이지로 이동하시겠습니까?`
          ),
          'info',
          async (current) => {
            // 저장 O, 페이지 이동 O
            this.openLoading()
            if (this.selectedKey === 0) {
              saveRiskAssessments(saveData, true)
                .then((response) => {
                  if (response.success) {
                    //
                  }
                })
                .catch((error) => {
                  console.error('btnsave error catch >> ', error)
                })
                .finally(() => {
                  this.endLoading()
                  this.$router.push(toRouter)
                })
            } else {
              const success = await this.saveShInfo()
              if (success) {
                this.$router.push(toRouter)
              }
            }
          },
          async (current) => {
            // 저장 X, 페이지 이동 O
            this.$router.push(toRouter)
          }
        )
      }
    },
    async handleTabClick(index) {
      if (this.selectedKey !== index) {
        let saveData = []
        if (index === 1) saveData = this.$refs.processPanelTree.datasource.filter((el) => el.__created__ || el.__updated__)
        if (saveData.length > 0) {
          this.vToastifySavePrompt(
            this.$t(`작성중인 데이터를 저장하시겠습니까?`),
            'info',
            async (current) => {
              this.openLoading()
              if (index === 1) {
                saveRiskAssessments(saveData, true)
                  .then((response) => {
                    if (response.success) {
                      //
                    }
                  })
                  .catch((error) => {
                    console.error('btnsave error catch >> ', error)
                  })
                  .finally(() => {
                    this.endLoading()
                    this.selectedKey = index
                    this.btnSearch(true)
                  })
              } else {
                const success = await this.saveShInfo()
                if (success) {
                  this.selectedKey = index
                  this.btnSearch(true)
                }
              }
            },
            async (current) => {
              this.selectedKey = index
              this.btnSearch(true)
            }
          )
        } else {
          this.selectedKey = index
          this.btnSearch(true)
        }
      }
    },
    changeRiskAssessment(value) {
      this.searchRiskAssessment = value
      this.searchProcess = ''
      const findData = this.riskAssessmentList.find((el) => el.assessmentKey === value)
      findData.latestYn == 'Y' ? (this.readOnlyFlag = false) : (this.readOnlyFlag = true)
      findData.riskEstimationVal1 == '' || findData.riskEstimationVal1 == null ? (this.fileMode = true) : (this.fileMode = false)
      this.btnSearch(true)
    },
    changeProcess(value) {
      this.searchProcess = value
      this.btnSearch(true)
    },
    getProcessCnt() {
      if (this.datasource) {
        let list = this.datasource.filter((element) => element.useYn == 'Y' && !element.__created__)
        return list.length
      }
      return 0
    },
    getWorkCnt() {
      if (this.datasource) {
        let cnt = 0
        this.datasource.forEach((element) => {
          let list = element.works.filter((element) => element.useYn == 'Y' && !element.__created__)
          cnt += list.length
        })
        return cnt
      }
      return 0
    },
    titleClick(selected) {
      this.selectedProcess = selected
      this.searchProcess = selected.processId?.toString()
    },
    onEditorPreparing(e) {
      if (e.parentType == 'dataRow') {
        var valueChanged = this.onCellValueChanged
        e.editorOptions.onValueChanged = (args) => {
          if (e.index > -1) {
            valueChanged(args.value, e)
          }
        }
      }
    },
    onCellValueChanged(value, cellInfo) {
      //인원 0미만 안되도록
      if (cellInfo.dataField == 'personInputCnt') if (value < 0) value = 0
      cellInfo.setValue(value)
    },
    apply(data) {
      this.datasource = data
    },
    setComboBox() {
      let params = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
        includeFileMode: true,
      }
      Promise.all([getRiskAssessments(params, false)]).then((response) => {
        this.riskAssessmentList = response[0].list
        if (this.riskAssessmentList.length != 0 && !this.searchRiskAssessment) {
          this.searchRiskAssessment = this.riskAssessmentList[0].assessmentKey
        }
        this.btnSearch(true)
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
